import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router";
import LoginPage from "./Components/LoginPage";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import NotFound from "./Components/NotFoundPage";

let routerConfig = createBrowserRouter([
  // {
  //   path: "/",
  //   element: <LoginPage />,
  // },
  {
    path: "/",
    element: <App />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

// let routerConfig = createBrowserRouter([
//   {
//     index: true,
//     path: "/",
//     element: <App />,
//   },
// ]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={appStore}>
    <RouterProvider router={routerConfig}>
      <div className="bg-gradient-to-b from-red-500 to-black h-screen">
        <App />
      </div>
    </RouterProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
